import { supabase } from "../lib/supabaseClient";

/**
 * Returns the user's most-configured brand row (the one with Business Basics
 * filled in). Day-1 heuristic until there's a real "active business" selector
 * for users with multiple brand profiles.
 */
export async function getActiveBrand() {
  const { data: auth, error: authErr } = await supabase.auth.getUser();
  if (authErr) throw authErr;

  const userId = auth?.user?.id;
  if (!userId) return null;

  const { data, error } = await supabase
    .from("brands")
    .select("*")
    .eq("user_id", userId)
    .not("description", "is", null)
    .order("updated_at", { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  return data;
}

export async function listOffers(brandId) {
  if (!brandId) return [];

  const { data, error } = await supabase
    .from("offers")
    .select("*")
    .eq("brand_id", brandId)
    .eq("is_active", true)
    .order("sort_order", { ascending: true });

  if (error) throw error;
  return data ?? [];
}

export async function listAudienceProfiles(brandId) {
  if (!brandId) return [];

  const { data, error } = await supabase
    .from("audience_profiles")
    .select("*")
    .eq("brand_id", brandId)
    .order("is_default", { ascending: false })
    .order("sort_order", { ascending: true });

  if (error) throw error;
  return data ?? [];
}

/**
 * audience_profiles is the authoritative source. brands.audience is a legacy
 * fallback only — used when a brand has no audience_profiles rows yet (older
 * accounts, or modules calling this before onboarding covers audience).
 * Do not write brands.audience going forward; it exists for backward
 * compatibility only and will eventually be removed.
 */
export async function getDefaultAudienceText(brand) {
  if (!brand?.id) return brand?.audience ?? "";

  const profiles = await listAudienceProfiles(brand.id);
  if (!profiles.length) return brand?.audience ?? "";

  return profiles[0].description || brand?.audience || "";
}
